<template>
	<div>
		<div
			v-if="priceType == 'FLAT'"
			class="mt-4 grid grid-cols-2 gap-y-4 gap-x-6"
			:key="'FLAT_' + priceType"
		>
			<ui-input-group
				v-model="form.price.mt"
				field="price.mt"
				label="Price"
				suffix="EUR/t"
				:form="form"
				:required="true"
				:dp="2"
			></ui-input-group>
		</div>

		<div
			v-else-if="priceType == 'INDEXED'"
			class="mt-4 grid grid-cols-2 gap-y-4 gap-x-6 items-end"
			:key="'INDEXED_' + priceType"
		>
			<ui-select-group
				v-model="form.price.commodity_future_id"
				field="price.commodity_future_id"
				type="select"
				label="Future"
				:options="futuresOptions"
				:form="form"
				:required="true"
			></ui-select-group>
			<ui-input-group
				v-model="form.price.basis"
				field="price.basis"
				label="Price Basis"
				:form="form"
				:required="true"
				suffix="EUR/t"
				:dp="2"
			></ui-input-group>
		</div>

		<div
			v-else-if="priceType == 'BASIS'"
			class="mt-4 grid grid-cols-2 gap-y-4 gap-x-6 items-end"
			:key="'BASIS_' + priceType"
		>
			<ui-select-group
				v-model="form.price.commodity_future_id"
				field="price.commodity_future_id"
				type="select"
				label="Future"
				:options="futuresOptions"
				:form="form"
				:required="true"
			></ui-select-group>
			<ui-input-group
				v-model="form.price.basis"
				field="price.basis"
				label="Price Basis"
				:form="form"
				:required="true"
				suffix="EUR/t"
				:dp="2"
			></ui-input-group>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			priceTypeOptions: ["FLAT", "INDEXED", "BASIS"],
		};
	},
	computed: {
		priceType: {
			get() {
				return this.form.price.type;
			},
			set(newValue) {
				this.form.price.type = newValue;
				if (newValue == "FLAT") {
					this.form.price.basis = null;
					this.form.price.commodity_future_id = null;
				} else {
					this.form.price.mt = null;
				}
			},
		},
		futuresOptions() {
			let tickers = {
					RAPE: "ECO",
					MAIZE: "EMA",
				},
				desiredTicker = tickers[this.form.product.type] || "EBM";
			return (this.activeFutures || [])
				.filter((f) =>
					this.form.product.type == "MAIZE"
						? f.ticker_code == desiredTicker || f.ticker_code == "EBM"
						: f.ticker_code == desiredTicker
				)
				.sort((a, b) =>
					a.ticker_code > b.ticker_code
						? 1
						: b.ticker_code > a.ticker_code
						? -1
						: 0
				);
		},
	},
};
</script>
